import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { TcsmSiteSettingsProps } from '../../../../../global/models/epi-model';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NotificationItem } from '../../../../notification/notification-item';
import { Notification, NotificationStatus } from '../../../../notification/notification-models';
import { MapNotification } from '../../../../../global/helpers/form-data-helper';


interface Props {
    notificationPath: string;
}
export function DashboardNotifications(props: Props) {

    const notifications = useSelector<TcsmStates, Notification[]>(state => state?.notificationState?.notifications?.filter(a => a.notification_status !== NotificationStatus.DISMISSED)?.slice(0, 3));
    const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);    	

    return (
        notifications?.length > 0 && 
        <DividerSection removeDivider>
            <ContentSpacer>
                {
                    notifications?.map(
                        (notification: Notification) => {
                            const mappedNotification = MapNotification(notification, siteSettings?.notificationMapping);
                            return <NotificationItem key={notification.notification_id.toString()} notification={mappedNotification} animateRemoval />;
                    })                        
                }
            </ContentSpacer>
            <Link className='btn-secondary' to={props.notificationPath}>{siteSettings?.alertNotificationCtaText}</Link>
        </DividerSection>
    );
}